import Composto from './Composto'

export default class CandidatoExperiencia {

  constructor() {
    this.id = 0;
    this.candidato_id = new Composto(),
      this.nome = "";
    this.data_entrada = "";
    this.data_atualmente = "";
    this.data_saida = "";
    this.cargo = "";
    this.motivo_saida = "";
    this.ramo_atividade = "";
    this.atividades = "";
    this.maquinas = "";
    this.experiencia_maquinas = false;
    this.sistemas = "";
    this.experiencia_sistemas = false;
    this.tp_registo = new Composto();
    this.ult_salario = 0;
    this.primeiro_emprego = "Nao";
  }
}
